import { render, staticRenderFns } from "./SubcontractorStatement.vue?vue&type=template&id=bd587d60&scoped=true"
import script from "./SubcontractorStatement.vue?vue&type=script&lang=js"
export * from "./SubcontractorStatement.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorStatement.vue?vue&type=style&index=0&id=bd587d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd587d60",
  null
  
)

export default component.exports